// Synchronized manually with backend constant (src/shared/legal/termsVersion.js)
// Update both when Terms & Conditions are revised
export const TERMS_VERSION = '2026-07-04';

export const TERMOS_E_CONDICOES_TEXT = {
  titulo: 'TERMOS E CONDIÇÕES DO LILY BOOK CLUB',
  dataAtualizacao: '04/07/2026',
  secoes: [
    {
      numero: '1',
      titulo: 'DO OBJETO',
      itens: [
        'O presente instrumento regula o relacionamento entre o CLUBE e o ASSOCIADO, estabelecendo as condições de participação na comunidade, a conduta esperada entre os membros, as modalidades de assinatura disponíveis e as regras de cancelamento, reembolso e uso do conteúdo produzido pelo CLUBE.',
      ],
    },
    {
      numero: '2',
      titulo: 'DAS MODALIDADES DE ASSINATURA',
      itens: [
        'LILY PASS: modalidade de ingresso comum e direto no CLUBE, disponível para qualquer pessoa interessada em se associar, sem necessidade de participação prévia.',
        'LILY MEMBER: categoria destinada aos ASSOCIADOS que tenham participado de, no mínimo, 4 (quatro) edições consecutivas do CLUBE, dando acesso a benefícios adicionais',
        'A migração de LILY PASS para LILY MEMBER ocorrerá automaticamente mediante a assiduidade no clube, uma vez cumprido o requisito de participação previsto acima.',
        'A ADMINISTRAÇÃO reserva-se o direito de criar, alterar ou descontinuar modalidades de assinatura, comunicando previamente os ASSOCIADOS.',
      ],
    },
    {
      numero: '3',
      titulo: 'DA CONDUTA DOS ASSOCIADOS',
      itens: [
        'Tratar todos os participantes com respeito e cordialidade, independentemente de opinião, gosto literário ou forma de interpretar as obras',
        'Não fazer ofensas, xingamentos, sarcasmo agressivo ou ataques pessoais a outros ASSOCIADOS',
        'Não criticar de forma desrespeitosa as escolhas de leitura, opiniões ou interpretações de outros participantes. Divergências são bem-vindas — desde que expressas com educação',
        'Não desrespeitar, questionar de forma agressiva ou desacatar as decisões e orientações da ADMINISTRAÇÃO',
        'Não fazer críticas destrutivas à obra do mês de forma a desmerecer o trabalho de curadoria ou o interesse de quem está lendo',
        'Não discutir política, religião ou outros temas sensíveis e polarizadores que não estejam relacionados à proposta do CLUBE, a fim de preservar a harmonia da comunidade',
        'Não compartilhar conteúdo discriminatório, preconceituoso, de ódio ou qualquer forma de assédio',
        'Evitar spam, divulgação de produtos/serviços não autorizados ou autopromoção sem consentimento da ADMINISTRAÇÃO',
      ],
    },
    {
      numero: '4',
      titulo: 'DAS PENALIDADES',
      itens: [
        'Advertência — aviso individual ou na comunidade, conforme a gravidade',
        'Suspensão temporária das atividades do CLUBE',
        'Remoção definitiva da comunidade e das atividades do CLUBE, sem necessidade de aviso prévio em casos graves (ofensas diretas, discurso de ódio, assédio)',
        'A ADMINISTRAÇÃO se reserva o direito de avaliar cada situação e tomar a decisão que considerar mais adequada para preservar o bem-estar coletivo',
      ],
    },
    {
      numero: '5',
      titulo: 'DA PRIVACIDADE E USO DE CONTEÚDO DA COMUNIDADE',
      itens: [
        'É vedado o compartilhamento de prints, áudios, mensagens ou qualquer conteúdo da comunidade com pessoas de fora, sem autorização prévia dos envolvidos',
        'Dados pessoais compartilhados na comunidade (nome, contato, opiniões) serão usados apenas para fins internos do CLUBE, em conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018)',
      ],
    },
    {
      numero: '6',
      titulo: 'DO CANCELAMENTO E REEMBOLSO',
      itens: [
        'Em caso de compra de vaga/mensalidade e impossibilidade de comparecimento, o ASSOCIADO deverá avisar a ADMINISTRAÇÃO com no mínimo 5 (cinco) dias de antecedência em relação à data do evento/encontro',
        'Avisando dentro do prazo: o ASSOCIADO terá direito a remanejar sua vaga para o encontro/mês seguinte, sem custo adicional',
        'Avisando fora do prazo (menos de 5 dias) ou em caso de não comparecimento sem aviso: não haverá direito a reembolso nem a remanejamento, sendo o valor pago integralmente retido pelo CLUBE, a título de cobertura de custos já organizados (materiais, reserva de espaço, etc.)',
        'Casos excepcionais (emergências médicas comprovadas, força maior) poderão ser avaliados individualmente pela ADMINISTRAÇÃO, a seu critério',
      ],
    },
    {
      numero: '7',
      titulo: 'DA PROPRIEDADE INTELECTUAL E CONFIDENCIALIDADE',
      itens: [
        'O nome, a logo, a identidade visual e os materiais originais produzidos pela ADMINISTRAÇÃO (roteiros de discussão, guias de leitura, cronogramas, artes, textos autorais etc.) são de propriedade do CLUBE e não podem ser copiados, redistribuídos ou usados para fins comerciais sem autorização',
        'Pede-se que os ASSOCIADOS não utilizem o nome, a marca ou os materiais do CLUBE para criar ou divulgar outra iniciativa concorrente',
        'Ao participar do CLUBE, o ASSOCIADO se compromete a: não divulgar, reproduzir ou utilizar comercialmente, fora do CLUBE, os materiais internos, dinâmicas, roteiros de discussão, critérios de seleção de obras, planilhas de organização e demais métodos de funcionamento desenvolvidos pela ADMINISTRAÇÃO; não utilizar esse conhecimento adquirido como ASSOCIADO para estruturar, no todo ou em parte substancial, um clube, comunidade ou negócio concorrente',
        'Em caso de descumprimento comprovado, a ADMINISTRAÇÃO poderá exigir a cessação do uso indevido e, havendo prejuízo demonstrável, buscar reparação por perdas e danos na forma da lei',
      ],
    },
    {
      numero: '8',
      titulo: 'DAS DISPOSIÇÕES GERAIS',
      itens: [
        'A ADMINISTRAÇÃO pode atualizar estes Termos a qualquer momento, com aviso prévio na comunidade. A continuidade da participação após o aviso implica concordância com as mudanças',
        'O presente instrumento é regido pelas leis da República Federativa do Brasil, aplicando-se, no que couber, o Código de Defesa do Consumidor (Lei nº 8.078/90)',
      ],
    },
    {
      numero: '9',
      titulo: 'DA ACEITAÇÃO DOS TERMOS',
      itens: [
        'O cadastro, a assinatura ou a simples participação nas atividades do CLUBE caracteriza, de maneira inequívoca, ampla, geral e irrestrita, a concordância do CONTRATANTE e do ASSOCIADO com todo o disposto no presente Termo',
      ],
    },
  ],
};
